import * as React from "react"
import { cn } from "@/lib/utils"

// Skeleton Loading Component with Shimmer Effect
const Skeleton = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-lg bg-muted relative overflow-hidden",
      "before:absolute before:inset-0 before:-translate-x-full",
      "before:animate-[shimmer_1.5s_infinite]",
      "before:bg-gradient-to-r before:from-transparent before:via-foreground/5 before:to-transparent",
      className
    )}
    {...props}
  />
))
Skeleton.displayName = "Skeleton"

// Skeleton variants for common use cases
const SkeletonText = ({ lines = 3, className }) => (
  <div className={cn("space-y-2", className)}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton 
        key={i} 
        className={cn(
          "h-4",
          i === lines - 1 ? "w-3/4" : "w-full"
        )} 
      />
    ))}
  </div>
)

const SkeletonCard = ({ className }) => (
  <div className={cn("p-6 border rounded-xl space-y-4", className)}>
    <div className="flex items-center gap-4">
      <Skeleton className="h-12 w-12 rounded-full" />
      <div className="space-y-2 flex-1">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
    <SkeletonText lines={2} />
  </div>
)

const SkeletonTable = ({ rows = 5, cols = 4, className }) => (
  <div className={cn("border rounded-xl overflow-hidden", className)}>
    <div className="bg-muted/50 border-b p-4 flex gap-4">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className="h-4 w-24" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex} className="p-4 flex gap-4 border-b last:border-0">
        {Array.from({ length: cols }).map((_, colIndex) => (
          <Skeleton key={colIndex} className="h-4 w-24" />
        ))}
      </div>
    ))}
  </div>
)

export { Skeleton, SkeletonText, SkeletonCard, SkeletonTable }
